import React, { useState } from 'react';
import { Form, Input, Button } from 'antd';

import Heading from '../../components/heading/heading';

import { AuthWrapper } from './styles';
import AuthLayout from '../../container/profile/authentication/Index';
import { api } from '../../services/api';
import toast from 'react-hot-toast';
import { useHistory, useLocation } from 'react-router-dom';

function ResetPassword() {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const history = useHistory();

  async function handleSubmit(data: { new_password: string }) {
    setIsLoading(true);

    const token = new URLSearchParams(location.search).get('token');
    if (!token) {
      toast.error('URL inválida.');
      return;
    }

    const res = await api.post('/reset-password', { ...data, token });
    setIsLoading(false);

    if (res.data.status === 200) {
      toast.success(res.data.message);
      history.push('/');
    } else {
      toast.error(res.data.message);
    }
  }

  return (
    <AuthWrapper>
      <div className="auth-contents">
        <Form onFinish={handleSubmit} layout="vertical">
          <Heading as="h3">Digite sua nova senha</Heading>

          <Form.Item
            rules={[{ message: 'Senha Obrigatória', required: true }]}
            name="new_password"
            initialValue=""
            label="Nova senha:"
          >
            <Input placeholder="******" />
          </Form.Item>

          <Form.Item style={{ flex: 1 }}>
            <Button className="btn-signin" htmlType="submit" type="primary" size="large">
              {isLoading ? 'Enviando...' : 'Enviar'}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </AuthWrapper>
  );
}

export default AuthLayout(ResetPassword);
